import React, { CSSProperties, ReactElement } from 'react'
import { RADOM_COLORS } from '../util/Constants'
import styled from 'styled-components'
import { unitFn } from '../util/Util'

interface IProps {
  disabled?: boolean
  checked: boolean
  onClick?: () => void
  sizeScale?: number
}

const SwitchWrapper = styled.div<{ isChecked: boolean, disabled?: boolean, sizeScale: number }>`
  background-color: ${({ isChecked }) => isChecked ? 'var(--primary-btn-bg, #171717)' : RADOM_COLORS.GRAY_DARK};
  border-radius: 50px;
  width: ${({ sizeScale }) => 42 * sizeScale}px;
  height: ${({ sizeScale }) => 24 * sizeScale}px;
  position: relative;
  display: flex;
  align-items: center;
  transition: 0.2s ease all;
  cursor: pointer;
  
  ${({ disabled }) => disabled && `
    cursor: default;
    opacity: 0.5;
  `}
  
  &:hover {
    background-color: ${({ isChecked }) => isChecked
    ? 'var(--primary-btn-bg-hover, #0f0f0f)'
    : RADOM_COLORS.GRAY_DARKER};
  }

  &:active {
    opacity: 0.75;
  }
`
const SwitchInput = styled.input<{ isChecked: boolean, disabled?: boolean, sizeScale: number }>`
  cursor: ${({ disabled }) => disabled ? 'default' : 'pointer'};
  appearance: none;
  width:  ${({ sizeScale }) => 18 * sizeScale}px;
  height: ${({ sizeScale }) => 18 * sizeScale}px;
  border-radius: 100%;
  margin: 0px;
  padding: 0px;
  position: absolute;
  left: ${({ checked, sizeScale }) => checked ? 21 * sizeScale : 3 * sizeScale}px;
  background-color: ${({ checked }) => checked ? 'var(--primary-btn-ink, #ffffff)' : '#ffffff'};
  transition: 0.2s ease all;
`

const Switch = ({ checked, disabled, sizeScale = 0.85, onClick }: IProps): ReactElement => {
  return <SwitchWrapper
    sizeScale={sizeScale}
    isChecked={checked}
    disabled={disabled}
    onClick={_ => { if (!disabled) onClick?.() }}>
    <SwitchInput
      sizeScale={sizeScale}
      disabled={disabled}
      onChange={unitFn}
      type="checkbox"
      checked={checked}
      isChecked={checked} />
  </SwitchWrapper>
}

// ---------------------------------------------------------------------------------------------------------------------
export interface SwitchWithLabelProps {
  onClickAction?: () => void
  state: boolean
  label: string
  disabled?: boolean
  labelStyle?: React.CSSProperties
  style?: CSSProperties
}

export const SwitchWithLabel = (props: SwitchWithLabelProps): ReactElement => {
  return <div
    style={{ cursor: 'pointer', userSelect: 'none', display: 'flex', alignItems: 'center', marginTop: 20, ...props.style }}
    onClick={props.onClickAction}>
    <Switch checked={props.state} disabled={props.disabled} onClick={props.onClickAction} />
    <div style={{
      flex: 1,
      color: RADOM_COLORS.GRAY_DARKEST,
      fontSize: 14,
      overflowWrap: 'break-word',
      marginLeft: 10,
      ...props.labelStyle
    }}>
      {props.label}
    </div>
  </div>
}
// ---------------------------------------------------------------------------------------------------------------------
export default Switch
